export default __webpack_public_path__ + "static/media/earnIcon_active.df7a4d16.svg";